import { getTVL } from "services";
import { useCallback, useEffect, useState } from "react";
import { useInterval, useIdle } from "react-use";

type TVLType = {
  value: number;
  usdTvl: number;
  usdPrice: number;
  symbol: string;
  name: string;
};

export type TVLDataType = {
  tvl: TVLType | undefined;
  isLoading: boolean;
};

const POLLING_INTERVAL = 10000;

const useTVL = () => {
  const isIdle = useIdle(150e3);

  const [data, setData] = useState<TVLDataType>({
    tvl: undefined,
    isLoading: true,
  });

  const fetchTVL = useCallback(async () => {
    const response = await getTVL();

    setData({
      tvl: response.data as TVLType,
      isLoading: false,
    });
  }, []);

  useEffect(() => {
    fetchTVL();
  }, [fetchTVL]);

  useInterval(() => {
    if (!isIdle) {
      fetchTVL();
    }
  }, POLLING_INTERVAL);

  return data;
};

export default useTVL;
